/**
 * Whether the socket debug instrumentation is active.
 *
 * Gated on `VUE_APP_ENV` rather than `NODE_ENV` deliberately: `package.json`'s
 * build script is `NODE_ENV=production vue-cli-service build`, so `NODE_ENV` is
 * `production` for every built mode — including `--mode testing`. Gating on it
 * would switch the instrumentation off on the test environment, which is
 * exactly where it is wanted.
 *
 * Written as two comparisons rather than an array `includes` so that the string
 * DefinePlugin inlines folds to a literal `false`, letting the minifier drop
 * the branch — and with it the overlay chunk — from a production build.
 */
export const SOCKET_DEBUG_ENABLED =
    process.env.VUE_APP_ENV === 'development' ||
    process.env.VUE_APP_ENV === 'testing';

/** How many recent socket events the service keeps for the overlay. */
export const SOCKET_DEBUG_LOG_LIMIT = 50;
